window.addEventListener('DOMContentLoaded', () => {
    var input = document.getElementById('handler-file');
    var btnUpload = document.getElementById('btn-upload');
    if (!input || !btnUpload) return;
    btnUpload.addEventListener('click', () => { input.click(); });
    input.addEventListener('change', handleImage);
});

function handleImage(e) {
    const file = e.target.files[0];
    const fileName = file.name;
    const fileExtension = fileName.split('.').pop().toLowerCase();
    
    if (!['jpg', 'jpeg', 'png'].includes(fileExtension)) {
        alert('Errore: Il file deve essere un\'immagine con estensione .jpg, .jpeg, o .png');
        document.getElementById('loader-screen').style.display = 'none';
        e.target.value = ''; // Reset del campo file
        return; // Interrompe l'esecuzione ulteriore della funzione
    }

    document.getElementById('loader-screen').style.display = 'block';
    resetUploadProgress(file);
    presignedUrl(file).then((data) => {
        console.info(data);
        document.getElementById('loader-screen').style.display = 'none';
        const productId = document.querySelector('span#product-id').textContent;
        const selectedVariantInput =
            document.querySelector('form[id^="product-form-template"] input[name="id"]') ||
            document.querySelector('product-form input[name="id"]');
        const sourceVariantId = selectedVariantInput ? selectedVariantInput.value : '';
        if (window.TPWallConfigRoute && (
            window.TPWallConfigRoute.supports(productId) ||
            window.TPWallConfigRoute.supportsLanding(productId)
        )) {
            const destination = window.TPWallConfigRoute.build({
                image: data.path,
                productId,
                sourceVariantId
            });
            location.assign(destination);
            return;
        }
        location.assign(`/pages/configuratore?image=${encodeURIComponent(data.path)}&product=${encodeURIComponent(productId)}`);
    }).catch((err) => {
        console.error(err);
        document.getElementById('loader-screen').style.display = 'none';
    });
}

function presignedUrl(file) {
    const shop = 'personalizza-tela.myshopify.com';
    const name = file.name;
    const type = file.type;
    const public = 1;
    const cb = rndNumber(18);
    const uri = `https://foto.telapersonalizzata.com/storage.php?shop=${shop}&name=${name}&type=${type}&public=${public}&cb=${cb}`;
    let storage;
    return fetch(uri).then((response) => {
        return response.json();
    }).then((response) => {
        storage = response;
        return putFile(storage, file);
    }).then(() => {
        return upload(storage, file);
    }).catch((err) => {
        console.info(err);
    })
}

function formatBytes(bytes) {
    if (!Number.isFinite(bytes) || bytes <= 0) return '0 MB';
    return `${(bytes / (1024 * 1024)).toFixed(1).replace('.', ',')} MB`;
}

function setUploadProgress(loaded, total) {
    const percentage = total > 0 ? Math.min(100, Math.round((loaded / total) * 100)) : 0;
    const bar = document.getElementById('tp-upload-bar');
    const percent = document.getElementById('tp-upload-percent');
    const bytes = document.getElementById('tp-upload-bytes');
    const subtitle = document.getElementById('tp-upload-subtitle');

    if (bar) bar.style.width = `${percentage}%`;
    if (percent) percent.textContent = `${percentage}%`;
    if (bytes && total > 0) bytes.textContent = `${formatBytes(loaded)} di ${formatBytes(total)}`;
    if (subtitle && percentage < 100) subtitle.textContent = 'Attendi qualche secondo';
}

function resetUploadProgress(file) {
    setUploadProgress(0, file && file.size ? file.size : 0);
    const subtitle = document.getElementById('tp-upload-subtitle');
    if (subtitle) subtitle.textContent = 'Attendi qualche secondo';
}

function completeUploadProgress(file) {
    setUploadProgress(file.size, file.size);
    const subtitle = document.getElementById('tp-upload-subtitle');
    if (subtitle) subtitle.textContent = 'Foto caricata correttamente · Prepariamo il configuratore…';
}

function putFile(data, file) {
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open('PUT', data.upload, true);

        xhr.upload.addEventListener('progress', (event) => {
            if (event.lengthComputable) {
                setUploadProgress(event.loaded, event.total);
            } else {
                setUploadProgress(event.loaded, file.size);
            }
        });

        xhr.addEventListener('load', () => {
            if (xhr.status >= 200 && xhr.status < 300) {
                completeUploadProgress(file);
                resolve(xhr);
            } else {
                reject(new Error(`Upload non riuscito (${xhr.status})`));
            }
        });

        xhr.addEventListener('error', () => reject(new Error('Errore di rete durante il caricamento')));
        xhr.addEventListener('abort', () => reject(new Error('Caricamento annullato')));
        xhr.send(file);
    });
}

function upload(data, file) {
    const payload = {
        name: file.name,
        size: file.size,
        mimeType: file.type,
        meta: {
            variant: "original",
            productId: 8061637722388,
            productHandle: "stampa-foto-tela",
            productTitle: "Stampa foto su tela",
            contentLength: file.size
        },
        url: data.download,
        path: data.path
    }
    const uri = 'https://foto.telapersonalizzata.com/upload.php?shop=personalizza-tela.myshopify.com&config=clvruqjhb2qh&token=6abceaa9-9db1-45a1-a280-1a7f30e3b0aa'
    return fetch(uri, {
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
    }).then((response) => {
        return response.json();
    }).then((data) => {
        console.info(data);
        return data;
    }).catch((err) => {
        console.error(err)
    })
}

function rndNumber(n) {
    return Math.floor(Math.random() * (9 * Math.pow(10, n - 1))) + Math.pow(10, n - 1);
}
